module.exports = __webpack_public_path__ + "static/assets/2946d5a288356584985cf180be715a9a.png";